import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import tagihanService from "../../services/tagihanService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tagihan: false,
    data_tagihan: [],
    showMessage:false,
    message:'',
}


export const getDataTagihan = createAsyncThunk('tagihan/data',async (data, { rejectWithValue }) => {
    try {
        const response = await tagihanService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const tagihanSlice = createSlice({
    name: 'tagihan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tagihan = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTagihan.fulfilled, (state, action) => {
                state.loading_tagihan = false
                state.data_tagihan = action.payload??[]
            })
            .addCase(getDataTagihan.pending, (state) => {
                state.loading_tagihan = true
            })
            .addCase(getDataTagihan.rejected, (state, action) => {
                state.loading_tagihan = false
                state.data_tagihan = action.payload
            })
    },
})

export const {
    showLoading,
} = tagihanSlice.actions

export default tagihanSlice.reducer
